import { createFileRoute } from "@tanstack/react-router"
import { CompanyServicesPage } from "@/features/companies/company-services-page"
export const Route = createFileRoute("/_authenticated/companies/$companyId/services/")({
    component: CompanyServicesPage,
})
